import React from 'react';

import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { AccessCustomerAccountButton } from '@admin/components/accounts/access_customer_acccount_button';
import { GenerateTestPassword } from '@admin/components/qa_automation/generate_test_password';

import { PrimaryToggle } from './primary_toggle';

interface CustomerEmailFieldProps {
  customerId?: number;
  email: string;
  isPrimaryEmail: boolean;
  required: boolean;
  onChange: (value: string) => void;
  onTogglePrimary: () => void;
}

/**
 * Component for rendering the customer email input with primary toggle and action buttons.
 *
 * @param props - The component props.
 * @returns The CustomerEmailField component.
 */
export const CustomerEmailField: React.FC<CustomerEmailFieldProps> = ({
  customerId,
  email,
  isPrimaryEmail,
  required,
  onChange,
  onTogglePrimary,
}) => (
  <>
    <table className="table">
      <tbody>
        <tr>
          <td>
            <FontAwesomeIcon icon={faEnvelope} />
          </td>
          <td>
            <input
              className="form-control"
              value={email}
              onChange={(e) => onChange(e.target.value)}
              placeholder="Email"
              required={required}
              type="email"
              aria-label="Customer email"
            />
          </td>
          <td>
            <PrimaryToggle isPrimary={isPrimaryEmail} showToggle={!!email} onToggle={onTogglePrimary} />
          </td>
        </tr>
      </tbody>
    </table>
    {customerId && (
      <>
        <GenerateTestPassword resourceID={String(customerId)} resourceType="Customer" email={email} />{' '}
        <AccessCustomerAccountButton customerID={String(customerId)} />
      </>
    )}
  </>
);
